type Props = {
  className?: string;
  title?: string;
};

const IconInfo = (props: Props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#c94b4b"
    className={props.className}
  >
    <title id="title">{props.title ? props.title : ""}</title>
    <g strokeWidth="0"></g>
    <g
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="#CCCCCC"
      strokeWidth="0.048"
    ></g>
    <g>
      {" "}
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="#c94b4b"
        strokeWidth="1.5"
      ></circle>{" "}
      <path
        d="M12 16V12"
        stroke="#c94b4b"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>{" "}
      <circle
        cx="1"
        cy="1"
        r="1"
        transform="matrix(1 0 0 -1 11 9)"
        fill="#c94b4b"
      ></circle>{" "}
    </g>
  </svg>
);

export default IconInfo;
